module.exports = __webpack_public_path__ + "img/bind_success.d3cc92a3.png";